import axios from 'axios'
import { addEvent } from '../assets/js/gtm'

axios.defaults.baseURL = process.env.API_URL
axios.defaults.withCredentials = true

export default function ({ $axios, app: { i18n, store, router }, localeRoute }) {
  let requests = 0
  let xhrRequests = 0

  $axios.onRequest((config) => {
    if (!config.headers['x-app-locale']) {
      config.headers['x-app-locale'] = i18n.locale
    }

    if (config.showLoader) {
      store.commit('SET_LOADING')
      requests++
    }

    if (config.method.toLowerCase() !== 'get') {
      config.xhrLoader = config.xhrLoader !== false
    }

    if (config.xhrLoader) {
      store.commit('SET_XHR_LOADING', true)
      xhrRequests++
    }
  })

  const xhrFinish = (response) => {
    if (response.config.showLoader) {
      requests--

      if (requests <= 0) {
        store.commit('SET_LOADING', false)
        requests = 0
      }
    }

    if (response.config.xhrLoader) {
      xhrRequests--

      if (xhrRequests <= 0) {
        store.commit('SET_XHR_LOADING', false)
        xhrRequests = 0
      }
    }

    if (response.headers && response.headers['x-tag-manager']) {
      const tagManagerEntries = JSON.parse(response.headers['x-tag-manager'])
      addEvent(tagManagerEntries)
    }

    return response
  }

  $axios.onResponse(response => xhrFinish(response))
  $axios.onResponseError((response) => {
    const statusCode = response?.response?.status || null

    if (!response.config.ignoreRedirects) {
      try {
        // eslint-disable-next-line no-console
        console.log('[Axios] got status code:', statusCode, response.config.url)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('[AXios] error:', e)
      }
      // if (statusCode === 401) {
      //   router.push(localeRoute({ name: 'index' }));
      // }
      // else if (statusCode === 403) {
      //   router.push({ name: 'dashboard' });
      // }
    }

    return Promise.reject(xhrFinish(response))
  })
}
